import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(AccountConfigService) {
        this.AccountConfigService = AccountConfigService;
    }

    $onInit() {
        this.applicationId = this.resolve.applicationId;
        this.accountId = this.resolve.accountId;
        this.config = this.resolve.config;
        this.elements = this.config.accountConfig.elements;
    }

    save() {
        this.AccountConfigService
            .save(this.applicationId, this.accountId, this.config)
            .then((response) => this.close({$value: response}))
            .catch((response) => this.spAlert = new SpAlert('danger', response.data.message));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-config/account-config.controller.js